import { Button, CircularProgress, Divider, Grid, Paper, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import Chart from "react-google-charts";
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useAppSelector } from '../../app/hooks';
import { getProjectDetails, getFanDetails, getFanData, getFetching, getFetchingError, createNewProject, getDrafts, getProjects, getGADetails } from '../../app/reducer/project.reducer';
import { ENCON_LOGO, GADRAWING } from '../../assets';
import { title } from 'process';

export default function Page5() {

  const dispatch = useDispatch();
  const history = useHistory();

  const [openErrAlert, setOpenErrAlert] = React.useState<boolean>(false);

  const projectDetails = useAppSelector(getProjectDetails) || {};
  const fanDetails = useAppSelector(getFanDetails);
  const gaDetails = useAppSelector(getGADetails);
  console.log(gaDetails)
  const fan = useAppSelector(getFanData);
  const projBusy = useAppSelector(getFetching);
  const fetchingErr = useAppSelector(getFetchingError);
  let projectDate: any;

  if (projectDetails.updatedAt) {
    projectDate = new Date(projectDetails.updatedAt + "");
  } else {
    projectDate = new Date();
  }
  let options = { year: 'numeric', month: 'long', day: 'numeric' };
  return (
    <Paper className="datasheet-paper" id="datasheet-page5" style={{ width: '100%', padding: '20px' }}>
      <div className="datasheet-row dark-gray">
        <Typography variant="h5" style={{ flex: 1, textAlign: 'center' }}>
          GA DRAWING
        </Typography>
      </div>
      <hr />

      <div className="datasheet-row light-gray">
        <Grid container spacing={3}>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ flex: 1, fontWeight: 600 }}>
                Project Name:
              </div>
              <div style={{ fontSize:'23px'}}>
                {projectDetails.project}
              </div>
            </div>
            <div className="data-field">
              <div style={{ flex: 1, fontWeight: 600 }}>
                Customer:
              </div>
              <div style={{ fontSize:'23px'}}>
                {projectDetails.consultant}
              </div>
            </div>
            <div className="data-field">
              <div style={{ flex: 1, fontWeight: 600 }}>
                Location:
              </div>
              <div style={{ fontSize:'23px'}}>
                {projectDetails.location}
              </div>
            </div>
          </Grid>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ flex: '1 1 60%', fontWeight: 600 }}>
                Date:
              </div>
              <div style={{ flex: '1 1 40%', textAlign: 'end' }}>
                {projectDate.toLocaleDateString("en-US", options)}
              </div>
            </div>
            <div className="data-field">
              <div style={{ flex: '1 1 60%', fontWeight: 600 }}>
                PO/SO No:
              </div>
              <div style={{ flex: '1 1 40%', textAlign: 'end' }}>
                {projectDetails.po_number}
              </div>
            </div>
            <div className="data-field">
              <div style={{ flex: '1 1 60%', fontWeight: 600 }}>
                Project Reference No:
              </div>
              <div style={{ flex: '1 1 40%', textAlign: 'end' }}>
                {projectDetails.project_number}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <br />
      <div className='red-border'>
        <div className="datasheet-row">
          <img src={fan.gaDrawing.imagePath} style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '100%', maxHeight: '100%' }} />
        </div>
        <br />

        <div className="datasheet-row datasheet-table" style={{ padding: '20px', marginTop: '20px', fontFamily: "serif", justifyContent: 'space-between', textTransform: 'uppercase' }}>

          <div style={{ zoom: 0.9 }}>
            <Grid container style={{ width: 800 }}>
              <Grid item xs={6} lg={6}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    LOCATION
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    MAKE
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    MODEL NO.
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    PART NO.
                  </div>
                </div>
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  FAN CASING DIA
                </div>
              </div> */}
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    FAN DIA
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    NO. OF BLADES
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    FAN RPM
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    FAN DRIVE
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    GEARBOX MODEL NO.
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    REDUCTION RATIO
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    MOTOR POWER
                  </div>
                </div>
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  MOTOR FRAME SIZE
                </div>
              </div> */}
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  SHAFT DIA (DΦ)
                </div>
              </div> */}
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  KEY WAY (W x D)
                </div>
              </div> */}
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    QTY.
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    ITEM CODE NO.
                  </div>
                </div>
              </Grid>

              <Grid item xs={6} lg={6}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.location}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.make}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.model_number}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.part_number}
                  </div>
                </div>
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:300}}>
                  {gaDetails.fan_diameter}
                </div>
              </div> */}
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.fan_diameter}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.no_of_blades}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.fan_rpm}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.fan_drive}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.gearbox_model_no}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.reduction_ratio}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.motor_power}
                  </div>
                </div>
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:300}}>
                  MOTOR FRAME SIZE
                </div>
              </div> */}
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:300}}>
                  SHAFT DIA (DΦ)
                </div>
              </div> */}
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:300}}>
                  KEY WAY (W x D)
                </div>
              </div> */}
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.qty}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.item_code_no}
                  </div>
                </div>
              </Grid>
            </Grid>

            <Grid container style={{ marginTop: '10px', width: 800 }}>
              <Grid item xs={1} lg={1}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    NO.
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    01
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    02
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    03
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    04
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    05
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    06
                  </div>
                </div>
              </Grid>
              <Grid item xs={4} lg={4}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    DESCRIPTION.
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    HUB SPOOL
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    HUB PLATE
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    CLAMP
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    CLAMP HARDWARE
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    HUB SPOOL HARDWARE
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    BLADES
                  </div>
                </div>
              </Grid>
              <Grid item xs={3} lg={3}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    MATERIAL
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.hub_spool_mat}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.hub_plate_mat}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.clamp_mat}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.clamp_hardware_mat}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.hub_spool_hardware_mat}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.blades_mat}
                  </div>
                </div>
              </Grid>
              <Grid item xs={3} lg={3}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    SPECIFICATION
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.hub_spool_spec}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.hub_plate_spec}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.clamp_spec}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.clamp_hardware_spec}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.hub_spool_hardware_spec}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.blades_spec}
                  </div>
                </div>
              </Grid>
              <Grid item xs={1} lg={1}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    QTY.
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.hub_spool_qty}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.hub_plate_qty}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.clamp_qty}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.clamp_hardware_qty}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.hub_spool_hardware_qty}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.blades_qty}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>


          <div style={{ zoom: 0.75, marginTop: '255px' }}>
            <Grid container style={{ zoom: 1.2, width: 800 }}>
              <Grid item xs={3} lg={3}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    DIMENSIONS
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    A
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    B
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    C
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    D
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    E
                  </div>
                </div>
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  F
                </div>
              </div>
              <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  G
                </div>
              </div> */}
              </Grid>

              <Grid item xs={3} lg={3}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    PARAMETER
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    FAN DIAMETER
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    BLADE LENGTH
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    HUB DIAMETER
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    BORE
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    KEYWAY
                  </div>
                </div>
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  BLADE SHOULDER
                </div>
              </div>
              <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  BLADE TIP
                </div>
              </div> */}
              </Grid>

              <Grid item xs={3} lg={3}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    VALUE
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.dimension_a && parseFloat(gaDetails.dimension_a).toFixed(3)}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.dimension_b && parseFloat(gaDetails.dimension_b).toFixed(3)}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.dimension_c && parseFloat(gaDetails.dimension_c).toFixed(3)}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.dimension_d && parseFloat(gaDetails.dimension_d).toFixed(3)}
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.dimension_e && gaDetails.dimension_e}
                  </div>
                </div>
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  &nbsp;{gaDetails.dimension_f && parseFloat(gaDetails.dimension_f).toFixed(3)}
                </div>
              </div>
              <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  &nbsp;{gaDetails.dimension_g && parseFloat(gaDetails.dimension_g).toFixed(3)}
                </div>
              </div> */}
              </Grid>

              <Grid item xs={2} lg={2}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    Unit
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    MM
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    MM
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    MM
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    MM
                  </div>
                </div>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    MM
                  </div>
                </div>
                {/* <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  MM
                </div>
              </div>
              <div className="data-field">
                <div style={{flex:1, fontWeight:600}}>
                  MM
                </div>
              </div> */}
              </Grid>
            </Grid>

            <Grid container style={{ zoom: 1.5, marginTop: '5px', width: 800 }}>
              <Grid item xs={4} lg={4}>
                <div className="data-field" style={{ height: '100%' }}>
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    UNLESS OTHERWISE SPECIFIED
                  </div>
                </div>
              </Grid>
              <Grid item container xs={8} lg={8}>
                <Grid item xs={12} lg={12} style={{ height: '50%' }}>
                  <div className="data-field" style={{ height: '100%' }}>
                    <div style={{ flex: 1, fontWeight: 600 }}>
                      CLIENT :-&nbsp;{projectDetails.consultant}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} lg={12} style={{ height: '50%' }}>
                  <div className="data-field" style={{ height: '100%' }}>
                    <div style={{ flex: 1, fontWeight: 600 }}>
                      P.O. NO. :-&nbsp;{gaDetails.po_number}&nbsp;&nbsp;DTD. :-&nbsp;{gaDetails.po_date}
                    </div>
                  </div>
                </Grid>
              </Grid>

              <Grid item xs={4} lg={4}>
                <div className="data-field" style={{ height: '100%' }}>
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    ALL DIMENSIONS ARE IN&nbsp;{gaDetails.unit}
                  </div>
                </div>
              </Grid>
              <Grid item xs={5} lg={5}>
                <div className="data-field" style={{ height: '100%' }}>
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    &nbsp;{gaDetails.ga_heading}
                  </div>
                </div>
              </Grid>
              <Grid item xs={3} lg={3}>
                <Grid item xs={12} lg={12} style={{ height: '50%' }}>
                  <div className="data-field" style={{ height: '100%' }}>
                    <div style={{ flex: 1, fontWeight: 600 }}>
                      CHECKED:
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} lg={12} style={{ height: '51%' }}>
                  <div className="data-field" style={{ height: '100%' }}>
                    <div style={{ flex: 1, fontWeight: 600 }}>
                      APPROVED:
                    </div>
                  </div>
                </Grid>
              </Grid>

              <Grid item xs={4} lg={4}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    DATE :-&nbsp;{gaDetails.ga_drawing_date}
                  </div>
                </div>
              </Grid>
              <Grid item xs={8} lg={8}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600 }}>
                    DRG. NO. :-&nbsp;{gaDetails.drawing_number}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} lg={12}>
                <div className="data-field">
                  <div style={{ flex: 1, fontWeight: 600, textAlign: 'center', fontSize: 40 }}>
                    &nbsp;{gaDetails.company_name}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>


        </div>
      </div>
      <br />
      <div className="data-footer">
        <hr />
        <div className="data-field">
          <div style={{ flex: '1 1 60%' }}>
            www.encongroup.co.in
          </div>
          <div style={{ flex: '1 1 40%', textAlign: 'end' }}>
            Page 5 of 5
          </div>
        </div>

      </div>
      <style>
        {`
          .red-border {
            border: 2px solid red;
            padding: 10px;
          }
        `}
      </style>
    </Paper>
  );
}


